module.exports = __webpack_public_path__ + "img/certified.06dbdcf9.svg";